import { isCookieRequiredCountry } from '@nike/ux-tread-privacy';
import { getGeolocCountry } from './geo';

/**
 * Get the country code to use for privacy reasons.
 * By default, this just returns the argument, unless using geoloc.
 * @param country {String} ie, US, GB
 * @param useGeoPrivacy {Boolean} should we use geoloc country to determine privacy?
 * @returns {String}
 */
export function getPrivacyCountry(country, useGeoPrivacy) {
  return (useGeoPrivacy ? getGeolocCountry() || country : country).toLowerCase();
}
/**
 * Check if we should respect privacy for given country and option.
 * @param country {String} ie, US, GB
 * @param useGeoPrivacy {Boolean} should we use geoloc country to determine privacy?
 * @returns {Boolean}
 */
export function shouldRespectPrivacy(country, useGeoPrivacy) {
  return isCookieRequiredCountry(getPrivacyCountry(country, useGeoPrivacy));
}
